function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.19 3.35l1.899-1.9c.5-.5 1.499-.2 1.599.5l1.3 7.6c.1.6-.4 1.2-1.1 1.1l-7.596-1.3c-.8-.1-1.1-1.1-.5-1.6l1.9-1.9c-3-3-7.797-3-10.795 0a7.608 7.608 0 000 10.8c2.998 3 7.796 3 10.794 0 .7-.7 1.9-.7 2.599 0 .7.7.7 1.9 0 2.6-4.398 4.4-11.594 4.4-15.992 0-4.397-4.4-4.397-11.6 0-16 4.398-4.4 11.494-4.3 15.892.1z",
  fill: "#231F20",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23"
  }, props), _ref);
};

export default SvgComponent;